import type { FC } from 'react'

import {
  ActionLink,
  ActionRow,
} from '@/apps/latest/components/molecules/ActionLink'
import { useReleaseChannel } from '@/features/auth'

interface Props {
  onHistory: () => void
  onPrescriptionReading: () => void
  onCreateTracingReport: () => void
  isHomeVisit: boolean
  hasTracingItem: boolean
  isTracingPending: boolean
  onFeedback: () => void
}

// 録音後の画面のページ下部に置く二次アクションの行 (design-book 02-components/patient-info-bar.md
// 「二次アクションはページ下部の低 emphasis テキスト行」)。⋯ には記録を仕上げる途中で手が伸びる
// ものだけを残し、見る (編集履歴) / 学ぶ (処方を読む) / 作る (トレーシング) / 当社へ伝える
// (改善依頼) はここへ出す。GA の店に出るのは 編集履歴 と 改善依頼 の 2 つ (yakureki-back log/231 D1)。
export const RecordActionRow: FC<Props> = ({
  onHistory,
  onPrescriptionReading,
  onCreateTracingReport,
  isHomeVisit,
  hasTracingItem,
  isTracingPending,
  onFeedback,
}) => {
  const { isBeta } = useReleaseChannel()
  return (
    <ActionRow gapTop={2}>
      <ActionLink label="編集履歴" onClick={onHistory} />
      {isBeta && (
        <ActionLink label="処方を読む" beta onClick={onPrescriptionReading} />
      )}
      {/* 在宅は報告書の「医師への伝達事項」に毎回自動で含まれるため、項目は見せて押せなくする
          (重複作成を防ぐ。理由は tooltip)。 */}
      {isBeta && (
        <ActionLink
          label={
            isTracingPending
              ? '作成中…'
              : hasTracingItem
              ? 'トレーシングレポートを再生成'
              : 'トレーシングレポートを作成'
          }
          beta
          disabled={isHomeVisit || isTracingPending}
          tooltip={
            isHomeVisit
              ? '在宅では報告書の「医師への伝達事項」に含まれます'
              : undefined
          }
          onClick={onCreateTracingReport}
        />
      )}
      <ActionLink label="改善依頼" onClick={onFeedback} />
    </ActionRow>
  )
}
